module.exports = __webpack_public_path__ + "static/media/g2.17cfdbfa.png";